export enum AuthEventType {
  TokenRefresh = 'tokenRefresh',
  TokenRefreshFailure = 'tokenRefresh_failure',
  Configured = 'configured',
  SignIn = 'signIn',
  AutoSignIn = 'autoSignIn',
  SignOut = 'signOut',
  SignInFailure = 'signIn_failure',
}
